import { createContext, Dispatch, SetStateAction } from 'react';
import type { ExerciseSession, QuizInformation } from '@openclassrooms/sdk-web';

interface CourseExerciseContextInterface {
  exerciseId: number;
  exerciseSession: ExerciseSession | null;
  isLoading: boolean;
  setExerciseSession: Dispatch<SetStateAction<ExerciseSession>>;
  quizInformation: QuizInformation | null;
  refetchQuizInformation: () => {};
}

export default createContext<CourseExerciseContextInterface>({} as CourseExerciseContextInterface);
